import { getTokenHeader } from "@/helpers/commonHelper";
import axios from "axios";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);
import { confirmWarningConfig } from "@/configuration/confirmConfigurations";
import EventFeatureEdit from "@/components/Events/EventFeatureEdit/EventFeatureEdit.vue";

export default {
  name: "GlobalFeatureConfig",
  props: [
    "featureGroups",
    "selectedFeatureGroups",
    "width",
    "buttonText",
    "global",
    "isEventAdmin"
  ],
  data: () => ({
    showFeatureInput: false,
    editedFeature: {
      title: "",
      shortTitle: "",
      pictureURL: "",
      mappingField: "",
      valueType: "",
      appdinx_channel_id: undefined,
      group: "",
      visible_to: "all",
      editable_by: "all",
      internal_control_feature: false
    },
    selectedGroup: {},
    showCreateInput: false,
    createInputValue: "",
    createInputValid: false
  }),
  methods: {
    toggleFeatureInput(id) {
      if (this.editedFeature?.feature_group === id) {
        this.showFeatureInput = !this.showFeatureInput;
        this.editedFeature.feature_group = this.showFeatureInput ? id : null;
      } else {
        this.showFeatureInput = true;
        // If only the feature_group is set, the component doesn't rerender
        this.editedFeature = { ...this.editedFeature, feature_group: id };
      }
    },
    async saveFeature(feature, method = "put") {
      const headers = getTokenHeader();
      try {
        const res = await axios[method](
          `${env.events_api_client_url}feature`,
          feature,
          {
            headers,
            params: {
              principal_id: this.selectedPrincipal.id
            }
          }
        );
        if (res.status === 200 || res.status === 201) {
          await this.$store.dispatch(
            "createSuccess",
            "Erfolgreich gespeichert!"
          );
          this.editedFeature = null;
          this.showFeatureInput = false;

          // No need to wait for this dispatch here
          // noinspection ES6MissingAwait
          await this.$store.dispatch("getFeatureGroupsForEvents", {
            getAll: true
          });
        }
      } catch (ex) {
        await this.$store.dispatch("createError", ex);
      }
    },
    async deleteGroup(group) {
      try {
        const confirmRes = await this.$confirm(
          `Wollen Sie die Gruppe wirklich löschen?`,
          confirmWarningConfig
        );
        if (confirmRes) {
          const headers = getTokenHeader();
          const res = await axios.delete(
            `${env.events_api_client_url}feature_group/${group._id}`,
            { headers, params: { principal_id: this.selectedPrincipal.id } }
          );
          if (res.status === 200) {
            await this.$store.dispatch("getFeatureGroupsForEvents", {
              getAll: true
            });

            await this.$store.dispatch(
              "createSuccess",
              "Erfolgreich gelöscht!"
            );
            this.snackbarColor = "#00636C";
            this.snackbar = true;
          } else
            await this.$store.dispatch(
              "createError",
              `Deletion failed with status: ${res.status}, reason: (${res.statusText})`
            );
        }
      } catch (ex) {
        await this.$store.dispatch("createError", ex);
      }
    },
    async deleteFeature(featureId) {
      if (featureId) {
        try {
          const confirmRes = await this.$confirm(
            `Wollen Sie dieses Merkmal wirklich löschen?`,
            confirmWarningConfig
          );
          if (confirmRes) {
            const headers = getTokenHeader();
            const res = await axios.delete(
              `${env.events_api_client_url}feature/${featureId}`,
              { headers, params: { principal_id: this.selectedPrincipal.id } }
            );
            if (res.status === 200) {
              await this.$store.dispatch("getFeatureGroupsForEvents", {
                getAll: true
              });
              await this.$store.dispatch(
                "createSuccess",
                "Feature wurde erfolgreich gelöscht"
              );
            }
          }
        } catch (error) {
          console.error(error);
        }
      }
    }
  },
  computed: {
    selectedPrincipal() {
      return this.$store.state.selectedPrincipal;
    },
    cSelectedFeatureGroups: {
      get() {
        return this.selectedFeatureGroups;
      },
      set(value) {
        this.$emit("setFeatureGroups", value);
      }
    }
  },
  components: { EventFeatureEdit }
};
